import { render } from "./app-form-invoice-additional-details.vue?vue&type=template&id=63b47d6d"
import script from "./app-form-invoice-additional-details.vue?vue&type=script&lang=js"
export * from "./app-form-invoice-additional-details.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/payje-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__